import configDefault from "./config-default";

const config = {
  ...configDefault,
  code: "iron-gym.org",
  favicon: "/irongym-favicon.png",
  title: "Je m'inscris | Iron Gym Villenoy",
  companyName: "Iron Gym Villenoy",
  website: "https://iron-gym.org/",
  notifyChannel: "vel-irongym",
  header: {
    title: "Je m'abonne",
    logo: "/irongym-header-logo.png",
    urlLogo: "https://iron-gym.org/",
  },
  footer: {
    // Le club n'a pas encore de page CGV publique (aucune dans son sitemap).
    // Le lien reste masqué tant qu'elle n'existe pas, plutôt que d'hériter du
    // lien de démo de config-default. Le lien d'optin peut aussi venir du BO
    // VEL via club.optin_href.
    cgv: null,
  },
  payByCard: "STRIPE",
};

export default config;
